<!-- This component is functionally identical to context-menu, but with changes
 to the positioning of the kebab menu and associated dropdown -->

<div class="e-context-dropdown">
    <button class="e-menu-button drop-btn" aria-controls="e-context-menu-geography">
        <span class="far fa-ellipsis-v"></span>
    </button>
    <div id="e-context-menu-geography" class="e-context-dropdown-content" role="menu">
        <ng-container *ngIf="menuOptions?.length">
            <a *ngFor="let option of menuOptions" (click)="onSelectMenuClick(option)" role="menuitem" context-menu-item>
                <span>{{ option.title }}</span>
            </a>
        </ng-container>
    </div>
</div>